export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-urban-border">
      <div className="max-w-7xl mx-auto px-8 md:px-16 py-16">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/eae5b4cf-72f5-4242-8c48-d94be5569ffc.png"
                  alt="Old Man Murks"
                  className="w-12 h-12 rounded-full object-cover border-2 border-red-700/60"
                />
              </div>
              <div>
                <p className="font-bebas text-2xl text-white tracking-widest">OLD MAN MURKS</p>
                <p className="font-rajdhani text-red-500 text-xs uppercase tracking-widest">Mike Barrett</p>
              </div>
            </div>
            <p className="font-rajdhani text-gray-500 text-sm leading-relaxed max-w-sm mb-6">
              Tactical shooter veteran proving that experience beats reflexes. Streaming, creating, and dominating since 2008. Old Man still murks.
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: "ri-twitch-fill", color: "text-purple-400 hover:text-purple-300" },
                { icon: "ri-youtube-fill", color: "text-red-500 hover:text-red-400" },
                { icon: "ri-twitter-x-fill", color: "text-gray-300 hover:text-white" },
                { icon: "ri-instagram-fill", color: "text-pink-400 hover:text-pink-300" },
                { icon: "ri-tiktok-fill", color: "text-cyan-400 hover:text-cyan-300" },
                { icon: "ri-discord-fill", color: "text-indigo-400 hover:text-indigo-300" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href="#social"
                  onClick={(e) => { e.preventDefault(); scrollTo("social"); }}
                  className={`w-9 h-9 flex items-center justify-center text-xl ${s.color} transition-colors cursor-pointer`}
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="font-rajdhani font-bold text-white uppercase tracking-widest text-sm mb-5">Navigate</p>
            <ul className="space-y-3">
              {[
                { label: "Home", id: "hero" },
                { label: "About Me", id: "about" },
                { label: "Game Highlights", id: "highlights" },
                { label: "Social Media", id: "social" },
                { label: "Gallery", id: "gallery" },
                { label: "Contact", id: "contact" },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="font-rajdhani text-gray-500 hover:text-red-400 text-sm transition-colors cursor-pointer whitespace-nowrap uppercase tracking-wider"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-rajdhani font-bold text-white uppercase tracking-widest text-sm mb-5">Games I Play</p>
            <ul className="space-y-3">
              {["Call of Duty: Warzone", "Escape From Tarkov", "Rainbow Six Siege", "PUBG", "Battlefield 2042", "The Division 2"].map((game) => (
                <li key={game}>
                  <span className="font-rajdhani text-gray-500 text-sm uppercase tracking-wider flex items-center gap-2">
                    <i className="ri-sword-fill text-red-900 text-xs" />
                    {game}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-urban-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-rajdhani text-gray-600 text-xs uppercase tracking-widest">
            &copy; {new Date().getFullYear()} Mike Barrett &mdash; Old Man Murks. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse" />
            <p className="font-rajdhani text-gray-600 text-xs uppercase tracking-widest">
              Built for the Murks Battalion
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
